export default __webpack_public_path__ + "static/media/time-option.75cb187a.png";